import { Check, ChevronsUpDown, Minus, Plus } from 'lucide-react'
import { useEffect, useState } from 'react'
import { cn } from '../../../../lib/utils'
import { Button } from '../../../components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../../components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover'
import { useToast } from '../../../hooks'
import { loadProducts } from './actions/load-products'

interface TabProductsProps {
  setProductsSelected: (product?: any) => void
  valueWatcher?: any
}

export function TabProducts({ setProductsSelected, valueWatcher }: TabProductsProps) {
  const { showToast } = useToast()
  const { data: products } = loadProducts()

  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')

  const [quantity, setQuantity] = useState(1)

  const plusQuantity = () => setQuantity(quantity + 1)
  const minusQuantity = () => {
    if (quantity <= 1) return
    setQuantity(quantity - 1)
  }

  useEffect(() => {
    if (products) {
      const data = products?.find((item) => item.id == value)
      if (data) {
        setValue(data.value)
      }
    }
  }, [products])

  const addInCart = () => {
    const data = products?.find((item) => item.id == value)
    if (data) {
      data.quantidade = quantity
      setProductsSelected(data)
      setQuantity(1)
      setValue('')
      showToast('Produto adicionado ao carrinho', 'success')
    }
  }

  useEffect(() => {
    if (valueWatcher) {
      setValue('')
    }
  }, [valueWatcher])

  return (
    <div className="w-full">
      <label className="font-semibold">Produtos</label>
      <div className="flex gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between">
              {value ? products?.find((item) => item.value === value)?.label : 'Selecione...'}
              <ChevronsUpDown className="opacity-50" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="min-w-full p-0">
            <Command>
              <CommandInput placeholder="Pesquisar..." className="h-9" />
              <CommandList>
                <CommandEmpty>Não encontrado.</CommandEmpty>
                <CommandGroup>
                  {products &&
                    products.map((item) => (
                      <CommandItem
                        key={item.value}
                        value={item.value}
                        keywords={[item.label]}
                        onSelect={(currentValue) => {
                          setValue(currentValue === value ? '' : currentValue)
                          setOpen(false)
                        }}
                      >
                        {item.label}
                        <Check className={cn('ml-auto', value === item.value ? 'opacity-100' : 'opacity-0')} />
                      </CommandItem>
                    ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>

        <Button className="bg-acelerafit-green-400 text-muted hover:bg-cashfit-green-200" onClick={addInCart}>
          Adicionar ao carrinho
        </Button>
      </div>

      <div className="mb-4 flex gap-2 mt-3">
        <label className="font-semibold">Quantidade</label>
        <div className="flex items-center gap-2">
          <Minus
            className="rounded-md shadow-md bg-acelerafit-green-100 text-acelerafit-gray-white cursor-pointer hover:bg-acelerafit-gray-white hover:text-acelerafit-green-100"
            onClick={minusQuantity}
          />
          {quantity}
          <Plus
            className="rounded-md shadow-md bg-acelerafit-green-100 text-acelerafit-gray-white   cursor-pointer hover:bg-acelerafit-gray-white hover:text-acelerafit-green-100"
            onClick={plusQuantity}
          />
        </div>
      </div>
      <div className=""></div>
    </div>
  )
}
